import {Toast} from 'ngx-toastr';

import {Component, ChangeDetectionStrategy} from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-custom-toast',
  templateUrl: './custom-toast.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./custom-toast.component.scss'],
})
export class CustomToastComponent extends Toast {
  showCloseButton: boolean;

  constructor() {
    super();
    switch (this.toastPackage.toastType) {
      case 'toast-success':
        this.bgClass = 'toast-bg-success';
        break;
      case 'toast-error':
        this.bgClass = 'toast-bg-error';
        break;
      case 'toast-warning':
        this.bgClass = 'toast-bg-warning';
        break;
      case 'toast-info':
        this.bgClass = 'toast-bg-info';
        break;
    }
    this.showCloseButton = this.toastPackage.config.disableTimeOut === true;
  }

  // used for demo purposes
  undoString = 'undo';
  bgClass: any;

  action(event: Event) {
    event.stopPropagation();
    this.undoString = 'undid';
    this.toastPackage.triggerAction();
    return false;
  }

  closeToast(event: Event) {
    event.stopPropagation();
    this.remove();
  }
}
